import { createFileRoute } from '@tanstack/react-router';
import { DesktopGantt } from '@/features/tasks/desktop/DesktopGantt';

export const Route = createFileRoute('/_app/tasks/gantt')({ component: DesktopGantt });
